export const SITE = {
  name: "K'REUSE EXTÉRIEUR",
  tagline: "Parcs et jardins • Lutte anti-nuisibles",
  zone: "Intervention en Creuse et alentours",
  phone: "07 80 54 11 15",
  phoneRaw: "+33780541115",
  whatsapp: "33780541115",
  email: "kreuseexterieur@gmail.com",
  facebook: "https://www.facebook.com/kreuseexterieur/",
  googleReview: "https://share.google/aeVs41zqROqtbhwSJ",
  googleWriteReview: "https://maps.app.goo.gl/soCwNTBtwaXhAd6g9?g_st=ic",
  logo: "/img/logo.webp",
};

export const PRICE_PAGES = [
  { slug: "paysagiste-creuse", label: "Paysagiste / création jardin" },
  { slug: "entretien-jardin-creuse", label: "Entretien de jardin" },
  { slug: "elagage-creuse", label: "Élagage / abattage" },
  { slug: "destruction-frelons-creuse", label: "Destruction nid frelons / guêpes" },
  { slug: "deratisation-creuse", label: "Dératisation" },
  { slug: "cafards-blattes-creuse", label: "Cafards / blattes" },
  { slug: "chenilles-processionnaires-creuse", label: "Chenilles processionnaires" },
  { slug: "punaises-de-lit-creuse", label: "Punaises de lit" },
  { slug: "desinsectisation-creuse", label: "Désinsectisation" },
  { slug: "desinfection-creuse", label: "Désinfection" },
];

export const LEGAL = {
  status: "SASU",
  siret: "93295212000016",
  address: "27 rue des Pradelles, 23800 La Celle-Dunoise",
  director: "TOURTEAU Kévin",
  tvaIntra: "FR39932952120",
  hosting: "Emergent (cloud hébergeur)",
};

export const PAYSAGISTE_SERVICES = [
  {
    title: "Création de jardins",
    desc: "Conception sur-mesure d'espaces verts adaptés à votre terrain et vos envies.",
  },
  {
    title: "Entretien de jardins",
    desc: "Contrats d'entretien réguliers : tonte, désherbage, nettoyage des massifs.",
  },
  {
    title: "Élagage & abattage",
    desc: "Taille et abattage d'arbres en toute sécurité, évacuation des déchets verts.",
  },
  {
    title: "Tonte de pelouse",
    desc: "Tonte régulière ou ponctuelle pour une pelouse impeccable toute l'année.",
  },
  {
    title: "Taille de haies",
    desc: "Taille précise et soignée de vos haies pour un extérieur structuré.",
  },
  {
    title: "Débroussaillage",
    desc: "Nettoyage des terrains en friche, mise en conformité débroussaillement.",
  },
];

export const NUISIBLES_SERVICES = [
  {
    title: "Frelons asiatiques",
    desc: "Destruction de nids en hauteur avec équipement spécialisé.",
  },
  {
    title: "Guêpes & frelons",
    desc: "Destruction de nids de guêpes et frelons (y compris asiatiques) en sécurité.",
  },
  {
    title: "Chenilles processionnaires",
    desc: "Échenillage et pose d'éco-pièges contre les chenilles du pin et du chêne.",
  },
  {
    title: "Cafards & blattes",
    desc: "Traitement ciblé des locaux infestés, méthodes professionnelles.",
  },
  {
    title: "Fouines & nuisibles",
    desc: "Solutions adaptées contre les fouines, blaireaux et autres nuisibles.",
  },
  {
    title: "Rats & souris",
    desc: "Diagnostic, piégeage et traitement durable contre les rongeurs.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Claire",
    text: "Kevin est venu labourer notre jardin, le service a été effectué très rapidement. La prestation est de qualité et à un prix très raisonnable. C'était une première expérience mais nous n'hésiterons pas à lui faire appel pour d'autres travaux extérieurs. Je recommande !",
  },
  {
    name: "Marlène",
    text: "Très réactif, disponible et avenant ! De bons conseils, à l'écoute et professionnel. Je recommande vivement en cas de besoin urgent ou non.",
  },
  {
    name: "Mireille",
    text: "Personne très agréable, très disponible et très réactif, aussi bien pour faire un devis que la réalisation des travaux. Ponctuel, travail soigné. Si besoin, je redemanderai ses services sans aucun problème, et je vais d'ailleurs en parler autour de moi. Tarif correct. Je recommande vivement.",
  },
  {
    name: "Nathalie",
    text: "Grand terrain 6300 mètres carrés : belle présentation, beau travail. Très satisfaite, merci et à bientôt !",
  },
  {
    name: "Julie",
    text: "Retour rapide et efficace, travail propre et soigné. Résultat impeccable !",
  },
  {
    name: "Marc",
    text: "Très bon travail, rapide et bien fait, et s'est bien adapté à mes attentes. Bravo !",
  },
  {
    name: "L. et F. Jardon",
    text: "Bravo Kevin, vos prestations correspondent en tous points à ce que l'on attendait, en espérant que la météo soit favorable à la pousse du gazon. — La Celle-Dunoise",
  },
  {
    name: "Muriel",
    text: "Kévin est très professionnel, à l'écoute et donne de très bons conseils. Les prix sont très raisonnables et le service rendu très efficace. Enfin un vrai jardinier paysagiste digne de ce nom. Je le recommande vivement.",
  },
  {
    name: "Hossain",
    text: "Kevin est très réactif pour répondre aux demandes, apporte des conseils utiles et réalise un travail de qualité.",
  },
];

export const GALLERY = [
  {
    src: "/img/photos/jardin-paysager.webp",
    alt: "Allée de jardin fleurie",
    label: "Création paysagère",
  },
  {
    src: "/img/photos/tondeuse.webp",
    alt: "Roseraie en fleur",
    label: "Massif de roses",
  },
  {
    src: "/img/photos/haie.webp",
    alt: "Entretien de massif",
    label: "Entretien",
  },
  {
    src: "/img/photos/massif-fleurs.webp",
    alt: "Paysagiste au travail",
    label: "Plantation",
  },
  {
    src: "/img/photos/tonte.webp",
    alt: "Pelouse tondue",
    label: "Tonte de pelouse",
  },
  {
    src: "/img/photos/elagage-arbre.webp",
    alt: "Élagage d'arbre",
    label: "Élagage",
  },
];

export const NAV = [
  { label: "Accueil", href: "/#accueil" },
  { label: "Services", href: "/#services" },
  { label: "Urgence", href: "/#urgence" },
  { label: "Conseils", href: "/conseils" },
  { label: "Avis", href: "/#avis" },
  { label: "Contact", href: "/#contact" },
];
